const PressModel = (data) => {
    return {...data.item, sourceItems: data?.sourceItems || [], isLoaded: data.item.blends.length > 0}
};

export default PressModel;
